import { useMutation, useQueryClient } from 'react-query';

import { useConfigurationStore } from 'store/configurationsStore';

import { setReport } from 'api/endPoints/setReport';

import { preparePayloadForReport } from 'components/Dashboards/Reporting/reporting.utils';

interface QueryResponse {
    id: number;
}

interface UseMutationAddWidgetLayoutToReportQueryParams {
    reportId: number;
    widgetId: string;
    sourceWidgetId?: number; //If passed, the new widget will be appended under, else to bottom
    insertAtTop?: boolean; //If true, the new widget will be inserted at the top, pushing other widgets down
}

export const UseMutationAddWidgetLayoutToReport = () => {
    const configurations = useConfigurationStore();

    const queryClient = useQueryClient();
    return useMutation<QueryResponse, QueryError, UseMutationAddWidgetLayoutToReportQueryParams>({
        mutationFn: async (params) => {
            const payload = await preparePayloadForReport(
                queryClient,
                params.reportId,
                Number(params.widgetId),
                configurations,
                params.sourceWidgetId,
                params.insertAtTop,
            );
            return setReport(payload);
        },
    });
};
